import React from "react";

import { List, Edit, Create, Datagrid, SimpleForm, TextInput, DeleteButton, EditButton, TextField } from "react-admin";

import LargePagination from "../core/LargePagination";
import { LVEditToolbar, LVCreateToolbar } from "../core/toolbars";

export const RoleList = (props) => (
    <List title="All Roles" perPage={500} pagination={<LargePagination />} {...props}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="value" />
            <EditButton />
            <DeleteButton mutationMode="pessimistic"/>
        </Datagrid>
    </List>
);

const classes = {
    textInput: {
        display: "flex",
        width: "20rem",
    },
};

const RoleTitle = ({ record }) => {
    return <span>Role {record ? `"${record.name}"` : ""}</span>;
};

const validateRoleCreation = (values) => {
    const errors = {};

    if (!values.name) {
        errors.name = "The Role Name is required";
    }
    if (!values.value) {
        errors.value = "The Role Value is required";
    }

    return errors;
};

const CoreFields = (props) => {
    return (
        <>
            <TextInput label="Role Name" source="name" sx={classes.textInput} />
            <TextInput label="Role Value" source="value" sx={classes.textInput} />
        </>
    );
};

export const RoleCreate = (props) => (
    <Create title="Create Role" {...props}>
        <SimpleForm validate={validateRoleCreation} toolbar={<LVCreateToolbar />}>
            <div>Create new Role</div>

            <CoreFields classes={classes} />
        </SimpleForm>
    </Create>
);

export const RoleEdit = (props) => (
    <Edit title={<RoleTitle />} {...props}>
        <SimpleForm toolbar={<LVEditToolbar />}>
            <TextInput disabled source="id" />

            <CoreFields classes={classes} />
        </SimpleForm>
    </Edit>
);
